import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import BoxedItem from '../../../../../../../../../components/global/BoxedItem';
import {
  FEATURE_SETS,
  getBoxFeaturesForSet,
  getBoxFooterForSet,
  getBoxHeaderForSet,
  isSetSelected,
} from '../../helpers';
import {
  SEARCH_SUBSCRIPTION_PLAN,
  SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD,
} from '../../../../../../../../temp/views/onboarding/PhotoSearchCheckout/helpers';

const propTypes = {
  set: PropTypes.oneOf(Object.values(FEATURE_SETS)).isRequired,
  searchSubscriptionItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      plan: PropTypes.oneOf(Object.keys(SEARCH_SUBSCRIPTION_PLAN)),
      billing_period: PropTypes.oneOf(
        Object.keys(SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD),
      ),
    }),
  ).isRequired,
  upgradeSelectionBoxesScroll: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }).isRequired,
  stepProps: PropTypes.object.isRequired,
  setStepProps: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  disableSubmit: PropTypes.bool,
  onSkip: PropTypes.func,
};
const UpgradeSelectionBox = ({
  set,
  searchSubscriptionItems,
  upgradeSelectionBoxesScroll,
  stepProps,
  setStepProps,
  handleSubmit,
  disableSubmit,
  onSkip,
}) => {
  const { searchSubscriptionItem } = stepProps;

  const [
    selectedSearchSubscriptionItem,
    setSelectedSearchSubscriptionItem,
  ] = useState(searchSubscriptionItems?.[0]);

  useEffect(() => {
    if (searchSubscriptionItems.includes(searchSubscriptionItem)) {
      setSelectedSearchSubscriptionItem(searchSubscriptionItem);
    }
  }, [searchSubscriptionItem]);

  const header = getBoxHeaderForSet({
    set,
  });
  const footer = getBoxFooterForSet({
    set,
    searchSubscriptionItems,
    upgradeSelectionBoxesScroll,
    selectedSearchSubscriptionItem,
    setSelectedSearchSubscriptionItem,
    stepProps,
    setStepProps,
    handleSubmit,
    disableSubmit,
    onSkip,
  });
  const features = getBoxFeaturesForSet({ set });

  return (
    <BoxedItem className={isSetSelected({ set, stepProps }) ? 'selected' : ''}>
      {header}
      <ul className="list-style-none">
        {features.map(feature => (
          <li key={feature.key}>{feature.value}</li>
        ))}
      </ul>
      <div className="mt-auto">
        <hr className="w-100 my-2" />
        {footer}
      </div>
    </BoxedItem>
  );
};

UpgradeSelectionBox.propTypes = propTypes;

export default UpgradeSelectionBox;
